import React from 'react'

import Wide from './wide'
import Tight from './tight'


const TwoColumn = ({wide, ...props }) => {

    if (wide) {
        return <Wide {...props} />
    }
    return <Tight {...props} />
}
export default TwoColumn